module.exports = __webpack_public_path__ + "img/ru.b7e32f2a.svg";